import { useTranslation } from 'react-i18next';

import { CopyableId } from '../CopyableText';

import { EntityRef } from '../EntityRef';
import { useAdminLookups } from '../../hooks/useAdminLookups';
import type { UserRole } from '../../types/api';
import { DetailField, DetailFieldGrid } from './DetailField';

export function UserRoleDetailPanel({ assignment }: { assignment: UserRole }) {
    const { t } = useTranslation();
    const lookups = useAdminLookups();
    const user = lookups.resolveUser(assignment.userId, assignment.user);
    const role = lookups.resolveRole(assignment.roleId, assignment.role);
    const empty = t('common.empty');

    return (
        <DetailFieldGrid>
            <DetailField
                label={t('fields.user')}
                value={
                    <EntityRef
                        title={user.title}
                        id={user.id}
                        secondary={user.secondary}
                        href={`/users?id=${assignment.userId}`}
                    />
                }
            />
            <DetailField label={t('fields.role')} value={<EntityRef title={role.title} id={role.id} />} />
            <DetailField label={t('fields.assignmentId')} value={<CopyableId id={assignment.id} />} />
            <DetailField
                label={t('fields.created')}
                value={
                    assignment.createdAt
                        ? new Date(assignment.createdAt).toLocaleString()
                        : empty
                }
            />
        </DetailFieldGrid>
    );
}
